export const GET_CONNECTIONS_DATA = 'GET_CONNECTION_DATA';
export const GET_CONNECTIONS_PROCESSING = 'GET_CONNECTION_PROCESSING';
export const GET_CONNECTIONS_ERROR = 'GET_CONNECTIONS_ERROR';
export const CONNECTIONS_TYPE_PROCESSING = 'CONNECTIONS_TYPE_PROCESSING';
export const SET_CONNECTION_TYPES = 'SET_CONNECTION_TYPES';
export const SET_CONNECTION_TYPES_ERR = 'SET_CONNECTION_TYPES_ERR';
export const ADD_CONNECTION_FLAG = 'ADD_CONNECTION_FLAG';
export const SET_EDIT_DATA = 'SET_EDIT_DATA';
export const SET_EDITABLE = 'SET_EDITABLE';
export const SET_PAYLOAD = 'SET_PAYLOAD';